interface PageMeta {
  title: string
  description: string
}

export function getPageMeta(pathname: string, locale?: string): PageMeta {
  if (locale === 'zh-CN') {
    return {
      title: 'BallPeek — 足球赛事监控与研究，不只看比分',
      description: '查看足球赛程、球队与球员历史、参考赔率和市场变化。BallPeek 标明资料来源、更新时间和缺失内容，帮助你了解比分背后的比赛背景。',
    }
  }

  return {
    title: 'BallPeek — Football Match Monitoring and Research',
    description: 'Follow football fixtures, explore team and player history, and understand market context with source and freshness notes.',
  }
}
